import GlobalCssStrings from "@/app/globalCssStrings"

function Kbd({
  className,
  ...props
}: React.ComponentProps<"button">) {

  return (
    <kbd
    className={className ?? GlobalCssStrings.KBD}
    {...props}/>
  )
}

export { Kbd }